module.exports = __webpack_public_path__ + "static/img/emhyr_imperial.5086bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/emhyr_imperial.png
// module id = Y/uB
// module chunks = 0